module.exports = __webpack_public_path__ + "static/media/moto.8c5fb418.jpg";